import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleCallback, extractUser } from '@/auth/oidc';
import { useAuthStore } from '@/stores/auth';

export function CallbackView() {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;

    handleCallback()
      .then((result) => {
        const user = extractUser(result.accessToken, result.idToken);
        useAuthStore.getState().setAuth(result.accessToken, user);

        // Navigate to saved URL — strip the base path if present
        const base = (import.meta.env.BASE_URL ?? '/').replace(/\/$/, '');
        let target = result.redirectUrl || '/';
        if (base && target.startsWith(base)) {
          target = target.slice(base.length) || '/';
        }
        navigate(target, { replace: true });
      })
      .catch((err) => {
        setError(err.message || 'Login mislukt');
        setTimeout(() => navigate('/', { replace: true }), 3000);
      });
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-td-bg font-sans flex items-center justify-center p-8">
        <div className="bg-white rounded-xl shadow-md p-8 max-w-md text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="text-lg font-bold text-td-navy mb-2">Login mislukt</h1>
          <p className="text-sm text-td-muted">{error}</p>
          <p className="text-xs text-td-light mt-2">Je wordt doorgestuurd...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-td-bg font-sans flex items-center justify-center">
      <p className="text-td-muted text-sm">Bezig met inloggen...</p>
    </div>
  );
}
